import React from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Box, Button } from "@mui/material";
import { PageMain } from "./Styles";

const NotFound = () => {
  return (
    <>
      <PageMain className="page_404">
        <Container>
          <Box
            sx={{ textAlign: "center", my: 4, mb: 0 }}
            className="four_zero_four_bg"
          >
            <Box sx={{ mb: 4 }}>
              <Typography variant="h1">404</Typography>
            </Box>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h3" component="h2" sx={{ mb: 2 }}>
              Look like you're lost
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              The page you are looking for is not available!
            </Typography>
            <Button component={Link} to="/" variant="contained">
              Go to Home
            </Button>
          </Box>
        </Container>
      </PageMain>
    </>
  );
};

export default NotFound;
